import { Breakpoint, Color, FontWeight, Icon, IconName, TypographyElement, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import {
  Answer,
  ArrowDownIcon,
  ArrowRightIcon,
  BlueTypography,
  Cell,
  Container,
  Content,
  DoubleCell,
  FirstContentCell,
  GrayTypography,
  HeaderCell,
  Headers,
  Label,
  List,
  ListItem,
  SubCell,
  Table,
  TablesWrapper,
  Title,
} from './trainingsGuide.styled';

export const TrainingsGuide: React.FC = (): JSX.Element => {
  const isTablet: boolean = useMediaQuery({ query: Breakpoint.Tablet });
  const { t }: TransProps<never> = useTranslation();

  return (
    <Container>
      <Title fontWeight={FontWeight.Bold} variant={TypographyVariant.TextLG}>{t('competence.app.trainings.trainingsGuide.title')}</Title>
      {isTablet ? (
        <Table>
          <Headers>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header1')}
              </GrayTypography>
              <ArrowRightIcon />
            </HeaderCell>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header2')}
              </GrayTypography>
              <ArrowRightIcon />
            </HeaderCell>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header3')}
              </GrayTypography>
            </HeaderCell>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header4')}
              </GrayTypography>
            </HeaderCell>
          </Headers>
          <Content>
            <FirstContentCell>
              <List>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.newCarsSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.newCarsFinansingSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.usedCarsSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.usedCarsFinansingSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.insuranceSeller')}
                  </GrayTypography>
                </ListItem>
              </List>
            </FirstContentCell>
            <DoubleCell>
              <SubCell>
                <Answer>
                  <Icon color={Color.Red900} name={IconName.Clear} size={22} />
                  <GrayTypography variant={TypographyVariant.TextSM}>
                    {t('competence.app.trainings.trainingsGuide.answerNo')}
                  </GrayTypography>
                </Answer>
              </SubCell>
              <SubCell>
                <Answer>
                  <Icon color={Color.Green900} name={IconName.Done} size={22} />
                  <GrayTypography variant={TypographyVariant.TextSM}>
                    {t('competence.app.trainings.trainingsGuide.answerYes')}
                  </GrayTypography>
                </Answer>
              </SubCell>
            </DoubleCell>
            <DoubleCell>
              <SubCell>
                <Label>
                  <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                    {t('competence.app.trainings.trainingsGuide.sp1')}
                  </BlueTypography>
                </Label>
              </SubCell>
              <SubCell>
                <Label>
                  <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                    {t('competence.app.trainings.trainingsGuide.sp2')}
                  </BlueTypography>
                </Label>
              </SubCell>
            </DoubleCell>
            <Cell>
              <Label>
                <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                  {t('competence.app.trainings.trainingsGuide.sp3')}
                </BlueTypography>
              </Label>
            </Cell>
          </Content>
        </Table>
      ) : (
        <TablesWrapper>
          <Table>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header1')}
              </GrayTypography>
              <ArrowDownIcon />
            </HeaderCell>
            <Cell>
              <List>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.newCarsSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.newCarsFinansingSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.usedCarsSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.usedCarsFinansingSeller')}
                  </GrayTypography>
                </ListItem>
                <ListItem>
                  <GrayTypography tag={TypographyElement.span} variant={TypographyVariant.TextXS}>
                    {t('competence.app.trainings.trainingsGuide.insuranceSeller')}
                  </GrayTypography>
                </ListItem>
              </List>
            </Cell>
          </Table>
          <Table>
            <Headers>
              <HeaderCell>
                <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                  {t('competence.app.trainings.trainingsGuide.header2')}
                </GrayTypography>
              </HeaderCell>
              <HeaderCell>
                <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                  {t('competence.app.trainings.trainingsGuide.header3')}
                </GrayTypography>
              </HeaderCell>
            </Headers>
            <Content>
              <Cell>
                <Answer>
                  <Icon color={Color.Red900} name={IconName.Clear} size={22} />
                  <GrayTypography variant={TypographyVariant.TextSM}>
                    {t('competence.app.trainings.trainingsGuide.answerNo')}
                  </GrayTypography>
                </Answer>
              </Cell>
              <Cell>
                <Label>
                  <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                    {t('competence.app.trainings.trainingsGuide.sp1')}
                  </BlueTypography>
                </Label>
              </Cell>
            </Content>
          </Table>
          <Table>
            <Headers>
              <HeaderCell>
                <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                  {t('competence.app.trainings.trainingsGuide.header2')}
                </GrayTypography>
              </HeaderCell>
              <HeaderCell>
                <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                  {t('competence.app.trainings.trainingsGuide.header3')}
                </GrayTypography>
              </HeaderCell>
            </Headers>
            <Content>
              <Cell>
                <Answer>
                  <Icon color={Color.Green900} name={IconName.Done} size={22} />
                  <GrayTypography variant={TypographyVariant.TextSM}>
                    {t('competence.app.trainings.trainingsGuide.answerYes')}
                  </GrayTypography>
                </Answer>
              </Cell>
              <Cell>
                <Label>
                  <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                    {t('competence.app.trainings.trainingsGuide.sp2')}
                  </BlueTypography>
                </Label>
              </Cell>
            </Content>
          </Table>
          <Table>
            <HeaderCell>
              <GrayTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextXS}>
                {t('competence.app.trainings.trainingsGuide.header4')}
              </GrayTypography>
            </HeaderCell>
            <Cell>
              <Label>
                <BlueTypography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
                  {t('competence.app.trainings.trainingsGuide.sp3')}
                </BlueTypography>
              </Label>
            </Cell>
          </Table>
        </TablesWrapper>
      )}
    </Container>
  );
};
